import { Container, Nav, Badge, Alert } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import { FaBoxes, FaHandshake, FaListUl, FaShoppingCart } from "react-icons/fa";
import { checkPermission } from "../../functions/checkPermission";

import GestionProveedores from "./components/GestionProveedores";
import CatalogoItems from "./components/CatalogoItems";
import OrdenesCompra from "./components/OrdenesCompra";

const HEADER_STYLE = {
  background: "linear-gradient(135deg, #3a3a3a 0%, #606060 100%)",
  color: "white",
  borderRadius: "15px",
  padding: "2rem",
};

const GestionComprasModulo = ({ usuario, seccion: propSeccion }) => {
  const { seccion: urlSeccion } = useParams();
  const navigate = useNavigate();
  
  // Prioridad: Prop (para ruta base) > URL Params
  const seccion = propSeccion || urlSeccion || "ordenes";

  const renderContent = () => {
    const tienePermiso = checkPermission(usuario, "compras", seccion.toUpperCase());
    
    if (!tienePermiso) {
      return (
        <Alert variant="danger" className="border-0 shadow-sm p-4">
          <h5 className="fw-bold">Acceso Denegado</h5>
          Usted no tiene permisos para acceder a la sección de Logística: <strong>{seccion.toUpperCase()}</strong>.
        </Alert>
      );
    }

    switch (seccion) {
      case "proveedores":
        return <GestionProveedores usuario={usuario} />;
      case "catalogo":
        return <CatalogoItems usuario={usuario} />;
      case "ordenes":
      default:
        return <OrdenesCompra usuario={usuario} />;
    }
  };


  return (
    <Container fluid className="p-4 animate__animated animate__fadeIn">
      {/* Header del Módulo de Logística */}
      <div style={HEADER_STYLE} className="shadow-sm mb-4">
        <div className="d-flex align-items-center mb-0">
          <div
            className="bg-white bg-opacity-20 p-3 rounded-3 me-3 d-flex align-items-center justify-content-center"
            style={{ width: "60px", height: "60px" }}
          >
            <FaShoppingCart size={30} />
          </div>
          <div className="flex-grow-1">
            <h2 className="fw-bold mb-1">Logística y Aprovisionamiento</h2>
            <p className="mb-0 opacity-75 small">
              Gestión de requerimientos, órdenes de compra y maestros de proveedores.
            </p>
          </div>
          <div className="d-none d-md-block text-end">
            <Badge bg="light" text="dark" className="px-3 py-2 rounded-pill shadow-sm">
              Módulo Independiente
            </Badge>
          </div>
        </div>
      </div>

      <div className="px-1">
        {renderContent()}
      </div>
    </Container>
  );
};

export default GestionComprasModulo;
